import React from 'react';
import { MBE_LOGO_URL } from '../mock';

export default function Footer() {
  return (
    <footer className="relative pt-16 pb-10 border-t border-white/5">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-2.5">
              <img src={MBE_LOGO_URL} alt="MBE International" className="h-9 w-auto object-contain" style={{ filter: 'brightness(0) invert(1)' }} />
            </div>
            <p className="mt-4 text-[#f2f2f2] text-[13px] leading-relaxed max-w-xs">
              The Road To Bali Challenge is a performance based Silver trading campaign by MBE International.
            </p>
          </div>

          <div>
            <div className="text-[#f2f2f2] text-sm font-semibold">Explore</div>
            <ul className="mt-3 space-y-2 text-[#f2f2f2] text-[13.5px]">
              <li><a href="#system" className="hover:text-white">System</a></li>
              <li><a href="#rewards" className="hover:text-white">Rewards</a></li>
              <li><a href="#bali" className="hover:text-white">Bali Trip</a></li>
              <li><a href="#faq" className="hover:text-white">FAQ</a></li>
            </ul>
          </div>

          <div>
            <div className="text-[#f2f2f2] text-sm font-semibold">Risk Disclaimer</div>
            <p className="mt-3 text-[#f2f2f2] text-[12.5px] leading-relaxed">
              Trading foreign exchange and CFDs on margin carries a high level of risk and may not be suitable for all investors. You should carefully consider your investment objectives, level of experience and risk appetite. T&Cs apply.
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3 text-[12px] text-[#f2f2f2]">
          <div>© {new Date().getFullYear()} MBE International. All rights reserved.</div>
          <div className="flex items-center gap-5">
            <a href="#" className="hover:text-white">Privacy Policy</a>
            <a href="#" className="hover:text-white">Terms & Conditions</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
